import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    De kracht van gezond eten en krachttraining bij een
                    vertraagde schildklier
                </title>
                <link rel="canonical" href={route("blogs.forty-six")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Wanneer u zich voortdurend vermoeid voelt, moeite heeft met afvallen of last heeft van een droge huid, kan het zijn dat uw schildklier niet optimaal functioneert. De schildklier, een klein orgaan in de hals, speelt een cruciale rol in ons lichaam. Het regelt de stofwisseling en beïnvloedt bijna alle metabolische processen in ons lichaam."
                />
                <meta
                    property="og:description"
                    content="Wanneer u zich voortdurend vermoeid voelt, moeite heeft met afvallen of last heeft van een droge huid, kan het zijn dat uw schildklier niet optimaal functioneert. De schildklier, een klein orgaan in de hals, speelt een cruciale rol in ons lichaam. Het regelt de stofwisseling en beïnvloedt bijna alle metabolische processen in ons lichaam."
                />
                <meta property="og:url" content={route("blogs.forty-six")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="De kracht van gezond eten en krachttraining bij een vertraagde schildklier - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/vertraagde-schildklier.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/vertraagde-schildklier.webp"
                                    type="image/webp"
                                    alt="Vertraagde schildklier"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/vertraagde-schildklier.jpg"
                                    type="image/jpeg"
                                    alt="Vertraagde schildklier"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/vertraagde-schildklier.jpg"
                                    alt="Vertraagde schildklier"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        De kracht van gezond eten en krachttraining bij een
                        vertraagde schildklier
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer u zich voortdurend vermoeid voelt, moeite heeft
                        met afvallen of last heeft van een droge huid, kan het
                        zijn dat uw schildklier niet optimaal functioneert. De
                        schildklier, een klein orgaan in de hals, speelt een
                        cruciale rol in ons lichaam. Het regelt de stofwisseling
                        en beïnvloedt bijna alle metabolische processen in ons
                        lichaam (Harvard Medical School, 2019).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Oorzaken van een vertraagde schildklier
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Een vertraagde schildklier, ook wel hypothyreoïdie
                        genoemd, kan verschillende oorzaken hebben. Het kan
                        bijvoorbeeld het gevolg zijn van een auto-immuunziekte,
                        waarbij het immuunsysteem de schildklier aanvalt en
                        beschadigt. Andere mogelijke oorzaken zijn bepaalde
                        medicijnen, behandelingen tegen een overactieve
                        schildklier of een tekort aan jodium in het dieet (Mayo
                        Clinic, 2021).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Gezond eten en krachttraining
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel medicatie vaak noodzakelijk is bij
                        hypothyreoïdie, kunnen ook gezonde voeding en
                        krachttraining een belangrijke rol spelen in het beheer
                        van deze aandoening. Een gezond, uitgebalanceerd dieet
                        kan helpen om het lichaam te voorzien van de nodige
                        voedingsstoffen en de algehele gezondheid en welzijn te
                        verbeteren. Het is belangrijk om voedingsmiddelen te
                        kiezen die rijk zijn aan jodium, zoals zeewier en vis,
                        omdat dit mineraal essentieel is voor de productie van
                        schildklierhormonen (Harvard Medical School, 2019).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast kan krachttraining helpen om de stofwisseling
                        te stimuleren en het energieniveau te verhogen.
                        Onderzoek toont aan dat krachttraining de
                        ruststofwisseling kan verhogen, wat kan helpen bij
                        gewichtsbeheersing, een veelvoorkomend probleem bij
                        mensen met een vertraagde schildklier (Westcott, 2012).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is duidelijk dat een vertraagde schildklier een
                        complexe aandoening is die een geïntegreerde aanpak
                        vereist. Naast medische behandeling kan een gezond
                        dieet, rijk aan essentiële voedingsstoffen, en
                        regelmatige lichamelijke activiteit, zoals
                        krachttraining, een positieve invloed hebben op het
                        beheersen van deze aandoening. Door goed voor uzelf te
                        zorgen, kunt u uw lichaam de beste kans geven om gezond
                        te blijven.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als u vermoedt dat u een vertraagde schildklier heeft,
                        is het belangrijk om medisch advies in te winnen. Samen
                        met uw arts kunt u een behandelplan opstellen dat past
                        bij uw unieke behoeften en levensstijl.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Harvard Medical School. (2019). The lowdown on thyroid
                        slowdown. Harvard Health Publishing.
                        <a
                            href="https://www.health.harvard.edu/diseases-and-conditions/the-lowdown-on-thyroid-slowdown"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://www.health.harvard.edu/diseases-and-conditions/the-lowdown-on-thyroid-slowdown
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Mayo Clinic. (2021). Hypothyroidism (underactive
                        thyroid).
                        <a
                            href="https://www.mayoclinic.org/diseases-conditions/hypothyroidism/symptoms-causes/syc-20350284"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://www.mayoclinic.org/diseases-conditions/hypothyroidism/symptoms-causes/syc-20350284
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Westcott, W. L. (2012). Resistance training is medicine:
                        effects of strength training on health. Current Sports
                        Medicine Reports, 11(4), 209-216.
                        <a
                            href="https://journals.lww.com/acsm-csmr/fulltext/2012/07000/resistance_training_is_medicine__effects_of.13.aspx"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://journals.lww.com/acsm-csmr/fulltext/2012/07000/resistance_training_is_medicine__effects_of.13.aspx
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
